export const ENV = {
  APP: {
    NAME: 'Magellan'
  },
  ONE_SIGNAL: {
    APP_ID: window.env.VUE_APP_ONESIGNAL_APP_ID
  }
}